// src/queryOptions.ts
function queryOptions(options) {
  return options;
}
export {
  queryOptions
};
